export function isEndpointRequest(requestUrl: string, endpointUrl: string): boolean {
  return requestUrl === endpointUrl || requestUrl.startsWith(`${endpointUrl}?`);
}
